import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  email: [
    validator('presence', true),
    validator('format', {
      type: 'email',
      allowNonTld: true,
    }),
  ],
  firstname: validator('presence', true),
  lastname: validator('presence', true),
});

export default class PersonModel extends Model.extend(Validations) {
  @attr('string') email;
  @attr('string') firstname;
  @attr('string') fon;
  @attr('string') lastname;

  // CMS Fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('category', { async: true, inverse: null }) gender;
  @hasMany('category', { async: true, inverse: null }) positions;
  @hasMany('section', { async: true, inverse: null }) sections;

  // Getter and setter
  get displayLabel() {
    return `${this.lastname}, ${this.firstname} (${this.id})`;
  }

  get displayHeadline() {
    return `${this.lastname}, ${this.firstname}`;
  }
}
